import { createContext } from 'react';

export const MovingPremisesProcessContext = createContext({});
